import { Link } from "react-router-dom";
import { Button, Input, Text, Heading } from "../../components";
import React from "react";

export default function UnifiedDigitalTwinSection() {
  return (
    <>
      {/* Unified Digital Twin Section */}
      <div className="mb-[140px] flex flex-col items-center self-stretch w-full">
        <div className="container-xs flex flex-col gap-[46px] px-2 md:px-5">
          <div className="mr-2.5 md:mr-0">
            <div className="flex flex-col items-start gap-[26px] md:pl-[50px]">
              <Heading
                size="heading16xl"
                as="h1"
                className="font-bold leading-[86px] text-white md:text-[48px] sm:text-[34px] sm:leading-[50px]"
              >
                <span>
                  Unified Digital Twin <br />
                  Platform
                </span>
              </Heading>
              <Text
                size="text9xl"
                as="p"
                className="font-normal leading-[42px] text-white md:text-[23px] sm:pr-5 sm:text-[18px] sm:leading-8"
              >
                <span>
                  Engineering and AI insights for manufacturers with remote <br />
                  factory monitoring and control to enable agile, data-driven
                  <br /> manufacturing
                </span>
              </Text>
            </div>
          </div>
          <div className="relative flex items-center w-full md:pl-[50px]">
            {/* Container for Input and Button */}
            <div className="flex w-full max-w-[520px] sm:max-w-[380px] relative">
              <Input
                size="sm"
                type="email"
                name="Email Input"
                placeholder={`Your business email`}
                className="w-full rounded-[16px] border border-color_style-01_neutrals-grey500 px-[18px] !text-color_style-01_neutrals-grey500 sm:pl-[18px]"
              />
              
                <Link
                  to="/bookademo"
                  style={{ textDecoration: "none", cursor: "pointer" }}
                >
                  <Button
                  size="xl"
                  shape="round"
                  className="absolute right-1 top-1/2 transform -translate-y-1/2 min-w-[146px] rounded-[12px] px-6 font-bold !text-white sm:min-w-[80px] sm:px-5"
                  >
                  Get a Demo
                  </Button>
                </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
